export class ChartItem {
  constructor(
    public label: string,
    public values: { [key: string]: number },
    public type?: string
  ) {}
}
